import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-0 mt-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Forget Password? ")
const _hoisted_3 = { class: "mt-10 flex" }
const _hoisted_4 = ["disabled"]

import axios, {
  AxiosError,
} from 'axios';
import type {
  LoginDto,
} from 'dto';
import {
  Form,
} from 'vee-validate';
import {
  ref,
} from 'vue';
import {
  object,
  string,
} from 'yup';
import InputHelper from '@/components/Helper/InputHelper.vue';
import {
  handleAxiosError,
} from '@/helpers';
import {
  ILoginInfo,
} from '@/type';

interface IFormSubmitValues {
  email: string;
  password: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
  formEnabled: {
    type: Boolean,
    required: true,
  },
},
  emits: ["auth"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'auth', value: ILoginInfo): void;
}), expose: any, slots: any, attrs: any }) {





const schema = object().shape({
  email: string()
    .label('E-mail')
    .email()
    .required(),

  password: string()
    .label('Password')
    .min(3)
    .required(),
});

const isSubmitting = ref(false);

const serverError = ref('');
async function onSubmit(values: IFormSubmitValues): Promise<void> {
  try {
    if (serverError.value) {
      return;
    }

    isSubmitting.value = true;

    const {
      email,
      password,
    } = values;

    const loginPayload: LoginDto = {
      username: email,
      password,
    };

    const loginResponse = await axios.post<ILoginInfo>(
      '/auth/login',
      loginPayload,
    );

    emits('auth', loginResponse.data);
  } catch (e: any) {
    if (e.isAxiosError) {
      const data = (e as AxiosError).response?.data as any;
      serverError.value = data.message;
    } else {
      handleAxiosError(e);
    }
  } finally {
    isSubmitting.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (__props.formEnabled)
    ? (_openBlock(), _createBlock(_unref(Form), {
        key: 0,
        class: "my-4 px-6",
        validationSchema: _unref(schema),
        onSubmit: onSubmit
      }, {
        default: _withCtx(({ isSubmitting: isValidatingForm }) => [
          _createVNode(InputHelper, {
            required: "",
            focused: "",
            name: "email",
            type: "email",
            label: "E-mail",
            placeholder: "Your email address",
            successMessage: "Got it!",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (serverError.value = ''))
          }),
          _createVNode(InputHelper, {
            required: "",
            name: "password",
            type: "password",
            label: "Password",
            placeholder: "Your password",
            successMessage: "Got it!",
            errorText: serverError.value,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (serverError.value = ''))
          }, null, 8, ["errorText"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_RouterLink, {
              class: "text-red-400",
              to: "/auth/reset-password"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass([{
          'btn-disabled': isSubmitting.value || isValidatingForm
        }, "btn-primary h-12 w-full bg-green-800 hover:bg-green-700"]),
              disabled: isSubmitting.value || isValidatingForm
            }, " Log in ", 10, _hoisted_4)
          ])
        ]),
        _: 1
      }, 8, ["validationSchema"]))
    : _createCommentVNode("", true)
}
}

})